import { render, staticRenderFns } from "./PageRegister.vue?vue&type=template&id=f8949cb6&"
import script from "./PageRegister.js?vue&type=script&lang=js&"
export * from "./PageRegister.js?vue&type=script&lang=js&"
import style0 from "./PageRegister.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageRegister.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fuser%2FPageRegister%2FPageRegister.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports